import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { StyledArrowDownIcon, StyledButtonWrapper, StyledCollapse } from './CollapsedText.styled';
import Button from './Button';
var CollapsedText = function CollapsedText(_ref) {
  var children = _ref.children,
    collapsedLines = _ref.collapsedLines,
    lineHeight = _ref.lineHeight,
    buttonLabel = _ref.buttonLabel,
    backgroundColor = _ref.backgroundColor,
    buttonJustify = _ref.buttonJustify;
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(100),
    collapsedSize = _useState2[0],
    setCollapsedSize = _useState2[1];
  useEffect(function () {
    if (collapsedLines > 0 && lineHeight > 0) {
      setCollapsedSize(collapsedLines * lineHeight);
    }
  }, [collapsedLines, lineHeight]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledCollapse, {
    backgroundColor: backgroundColor,
    collapsedSize: collapsedSize,
    in: open,
    lineHeight: lineHeight
  }, children), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: buttonJustify
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(StyledButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    color: "primaryAlt",
    variant: "outlined",
    size: "small",
    onClick: function onClick() {
      return setOpen(!open);
    },
    endIcon: buttonJustify === 'flex-end' ? /*#__PURE__*/React.createElement(StyledArrowDownIcon, {
      open: open
    }) : null,
    startIcon: buttonJustify !== 'flex-end' ? /*#__PURE__*/React.createElement(StyledArrowDownIcon, {
      open: open
    }) : null
  }, function () {
    if (buttonLabel && buttonLabel.open && buttonLabel.closed) {
      return open ? buttonLabel.open : buttonLabel.closed;
    }
    return open ? 'Less' : 'More';
  }())))));
};
CollapsedText.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * @ignore
   */
  children: PropTypes.any.isRequired,
  /**
   * Number of lines to show
   */
  collapsedLines: PropTypes.number,
  /**
   *  The height of a line (used to create a gradient mask over the last line of text)
   */
  lineHeight: PropTypes.number,
  /**
   * Labels to show on the button when open and closed
   */
  buttonLabel: PropTypes.shape({
    open: PropTypes.string,
    closed: PropTypes.string
  }),
  /**
   * Used to create gradient masks to show the user that there is hidden text (6 character hex value)
   */
  backgroundColor: PropTypes.string,
  /**
   * Position for the button
   */
  buttonJustify: PropTypes.oneOf(['flex-start', 'center', 'flex-end'])
} : {};
CollapsedText.defaultProps = {
  collapsedLines: 0,
  lineHeight: 0,
  buttonLabel: null,
  backgroundColor: '#ffffff',
  buttonJustify: 'flex-start'
};
export default CollapsedText;